import {SET_MOBILE_FLAG, SET_TITLE} from "../action/appActions";

export function appReducer(state = {}, action) {
    switch (action.type) {
        case SET_TITLE:
            return {
                ...state,
                title: action.title
            }

        case SET_MOBILE_FLAG:
            return {
                ...state,
                isMobile: action.isMobile
            }

        default:
            return state
    }
}